import { useContext } from '@codeleap/hooks'
import { SearchContext } from '@giphy/react-components'

export const useGIFs = () => {
  const props = useContext(SearchContext)

  return props
}

